import React from 'react';
import { injectIntl } from 'react-intl';

import { Icon, MaterialHint } from 'shared/components';
import commonFilterTheme from './IconWithHint.scss';


const IconWithHint = ({ intl, openPopover }) => (
  <MaterialHint
    placement="top"
    title={ intl.formatMessage({ id: 'Appointment.NavigationBar.OptionsButton.Tooltip', defaultMessage: '** Option' }) }
  >
    <button
      className={ commonFilterTheme.filterIconContainer }
      onClick={ openPopover }
      data-testid="three-dot-button-for-dropdown-menu-call"
      aria-label={ intl.formatMessage({ id: 'Appointment.NavigationBar.OptionsButton.Tooltip', defaultMessage: '** Option' }) }
    >
      <Icon name="dots-menu" />
    </button>
  </MaterialHint>
);

export default injectIntl(IconWithHint);
